<script>

    export default {
        data () {
            return {

            }
        },
        mounted () {
            if (this.id.length) {
                this.show(this.id)
            }
        },
        props: [
            'id'
        ],
        template: '<span></span>',
        methods: {
            show (modalName) {
                this.$modal.show(modalName);
            },
            hide () {
                this.$modal.hide(modalName);
            }
        }
    }
</script>
